import {defaultFont} from '../../styles/style';

const style = {
  form: {
    marginTop: '5px',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
  },
  form__item: {},
  form__error: {
    ...defaultFont,
    fontSize: '14px',
  },
};

export default style;
